(function () {
  'use strict';
  var root = document.querySelector('[data-csc-profile-certificate]');
  if (!root || !window.fetch) return;
  var profileUrl = root.dataset.profileUrl || '';
  var endpoint = root.dataset.endpoint || '';
  if (!profileUrl || !endpoint) return;
  function text(value) { return String(value || '').trim(); }
  function addFact(list, label, value) {
    if (!text(value)) return;
    var item = document.createElement('div');
    var term = document.createElement('dt');
    var description = document.createElement('dd');
    term.textContent = label + ':';
    description.textContent = value;
    item.appendChild(term);
    item.appendChild(description);
    list.appendChild(item);
  }
  function renderSignets(modules) {
    var moduleSignets = root.querySelector('[data-csc-profile-certificate-signets]');
    if (!moduleSignets || !Array.isArray(modules)) return;
    var selected = {};
    modules.forEach(function (module) {
      if (module === 'living-soil') selected['living-soil'] = true;
      if (module === 'erde-substrat') selected['erde-substrat'] = true;
      if (['hydro-soilless', 'dwc-rdwc', 'nft', 'aeroponik', 'steinwolle'].indexOf(module) > -1) selected['hydro-soilless'] = true;
    });
    Object.keys(selected).forEach(function (module) {
      var signet = moduleSignets.querySelector('[data-csc-profile-certificate-signet="' + module + '"]');
      if (signet) signet.hidden = false;
    });
    moduleSignets.hidden = Object.keys(selected).length === 0;
  }
  var requestUrl = endpoint + '?profile=' + encodeURIComponent(profileUrl);
  fetch(requestUrl, { headers: { Accept: 'application/json' } })
    .then(function (response) { if (!response.ok) throw new Error('certificate lookup failed'); return response.json(); })
    .then(function (payload) {
      var item = Array.isArray(payload.items) ? payload.items.find(function (entry) { return entry.public_status === 'aktiv'; }) : null;
      if (!item) return;
      var summary = root.querySelector('[data-csc-profile-certificate-summary]');
      var facts = root.querySelector('[data-csc-profile-certificate-facts]');
      var link = root.querySelector('[data-csc-profile-certificate-link]');
      summary.textContent = text(item.public_summary) || 'Dieser Club erfüllt den veröffentlichten Prüfstatus im angegebenen Gültigkeitszeitraum.';
      addFact(facts, 'Zertifikat', item.certificate_number);
      addFact(facts, 'Gültig bis', item.expires_at);
      addFact(facts, 'Bereiche', Array.isArray(item.modules) ? item.modules.join(', ') : '');
      renderSignets(item.modules);
      link.href = '/pages/csc-zertifikat-pruefen?q=' + encodeURIComponent(item.certificate_number || item.club_name || '');
      root.hidden = false;
    })
    .catch(function () { /* Bei nicht erreichbarem Portal wird kein Zertifizierungsstatus behauptet. */ });
}());
